export const filterFieldTypes = {
    bool: 'bool',
    date: 'date',
    disabled: 'disabled',
    number: 'number',
    select: 'select',
    text: 'text'
};
